import AIShowcaseItem from './AIShowcaseItem';

export default AIShowcaseItem;
export type { AISolution } from './AIShowcaseItem';
